import { render, staticRenderFns } from "./serviceSelect.vue?vue&type=template&id=68617004&scoped=true&"
import script from "./serviceSelect.vue?vue&type=script&lang=js&"
export * from "./serviceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68617004",
  null
  
)

export default component.exports